module.exports = __webpack_public_path__ + "media/images/official/special_migration_12-adaa5f7cb0ba30dd3e8b82cfc96f8e99.jpg";